/**
 * Componente Loading
 * Wrapper para o Spin do Ant Design
 */

import React from "react";
import { Spin } from "antd";

const Loading = ({ size = "default", text, fullScreen = false, className }) => {
  const sizeMap = {
    sm: "small",
    md: "default",
    lg: "large",
    xl: "large",
  };

  if (fullScreen) {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(255, 255, 255, 0.9)",
          gap: "16px",
        }}
      >
        <Spin size={sizeMap[size]} />
        {text && <div style={{ color: "#666", fontSize: "14px" }}>{text}</div>}
      </div>
    );
  }

  return (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "12px",
        padding: "20px",
      }}
    >
      <Spin size={sizeMap[size]} />
      {text && <div style={{ color: "#666", fontSize: "14px" }}>{text}</div>}
    </div>
  );
};

export default Loading;
